/* */ 
(function(Buffer) {
  'use strict';
  var BINARY_REGEXP = /\.(jpeg|jpg|gif|png|bmp|ico)$/i;
  module.exports = {
    order: 400,
    allowEmpty: true,
    canParse: function isBinary(file) {
      return Buffer.isBuffer(file.data) && BINARY_REGEXP.test(file.url);
    },
    parse: function parseBinary(file) {
      if (Buffer.isBuffer(file.data)) {
        return file.data;
      } else {
        return new Buffer(file.data);
      }
    }
  };
})(require('buffer').Buffer);
